import { coreService } from "../../../../../services/coreService";
import { buildQuery } from "../../../../../lib/network";

export interface InspectionsRequestUpdateReqBody {
  data: {
    schedulingPreferencesMessage: string | null;
    schedulingPreferences: {
      preferredDate: string;
      meridiem?: "AM" | "PM" | null;
    }[];
    onSiteContactName: string | null;
    onSiteContactApplicantInstructions: string | null;
    onSiteContactPhone: string | null;
  };
}
export default function putPublicInspectionRequest(headers: any, id: number) {
  return (data: InspectionsRequestUpdateReqBody) => {
    return buildQuery(coreService.inspectionsPublicRequestUpdate(id, data, { headers }), (response) => {
      return response.data;
    });
  };
}
